import axiosInstance from '../../../constants/axiosInstance';
import { ApiResponse, Option } from '../types/taskForm';

interface WorkflowOption {
    workflowId: string;
    name: string;
}

interface SkillOption {
    skillId: string;
    name: string;
}

interface SensorTagOption {
    label: string;
    value: string;
}

interface TaskCompletionStateOption {
    transitionOptionId: string;
    label: string;
}

export const fetchWorkflowOptions = async (queryValue: string): Promise<WorkflowOption[]> => {
    const response = await axiosInstance().get<ApiResponse<WorkflowOption[]>>(
        `/taskManagement/getListOfWorkflowForTaskTemplateAutocomplete`,
        {
            params: { workflow: queryValue },
        }
    );
    return response.data?.data;
};

export const fetchSkillsOptions = async (queryValue: string): Promise<SkillOption[]> => {
    const response = await axiosInstance().get<ApiResponse<SkillOption[]>>(
        `/taskManagement/getListOfSkillsAutocomplete`,
        {
            params: { skill: queryValue },
        }
    );
    return response.data?.data;
};

export const fetchSensorTagsOptions = async (queryValue: string): Promise<SensorTagOption[]> => {
    const response = await axiosInstance().get<ApiResponse<SensorTagOption[]>>(
      `/taskManagement/listOfSensorTagsForTaskTemplateAutocomplete`,
      {
        params: { sensorTag: queryValue },
      }
    );
    return response.data.data;
  };

  export const fetchSensorTagIdsOptions = async (queryValue: string): Promise<SensorTagOption[]> => {
    const response = await axiosInstance().get<ApiResponse<SensorTagOption[]>>(
      `/taskManagement/getListOfDiSensors`,
      {
        params: { sensorTag: queryValue },
      }
    );
    return response.data.data;
  };
  
export const fetchTaskCompletionStateOptions = async (workflowId: string): Promise<TaskCompletionStateOption[]> => {
    const response = await axiosInstance().get<ApiResponse<TaskCompletionStateOption[]>>(
        `/taskManagement/getListOfDoneOptionsInWorkflow`,
        {
            params: { workflowId },
        }
    );
    return response.data?.data;
};

export const timeOptions: Option[] = [
    { label: 'Minute(s)', value: 'Minute(s)' },
    { label: 'Hour(s)', value: 'Hour(s)' },
    { label: 'Day(s)', value: 'Day(s)' },
    { label: 'Week(s)', value: 'Week(s)' },
];